import { CanActivateFn, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest, filter, map, of, switchMap } from 'rxjs';
import { select, Store } from '@ngrx/store';
import {
  UserSessionsState,
  UserSessionStoreSelectors,
} from '@booking-booster-client/root-store';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard {
  constructor(
    private router: Router,
    private store: Store<UserSessionsState>,
    private authService: AuthService,
  ) {}

  canActivate: CanActivateFn = ({ data }) => {
    return this.authService.isInitialized$.pipe(
      filter((initialized) => initialized), // Ensure initialization is complete
      switchMap(() => {
        if (this.authService.hasValidAccessToken()) {
          // Combine user and error observables into one
          return combineLatest([
            this.store.pipe(select(UserSessionStoreSelectors.selectUser)),
            this.store.pipe(select(UserSessionStoreSelectors.selectError)),
          ]).pipe(
            filter(([user, error]) => !!user || !!error), // Wait for either a user or error
            map(([user]) => {
              if (!user) {
                return this.router.createUrlTree(['/signin']);
              }

              const { role } = data;
              const { isSystem } = user;

              if (role === 'admin') {
                if (isSystem) {
                  return true;
                }
                return this.router.createUrlTree(['/']);
              }

              if (isSystem) {
                return this.router.createUrlTree(['/admin']);
              }

              return true;
            }),
          );
        } else {
          // Trigger login flow and redirect to home
          this.authService.initLoginFlow();
          return of(false); // Wrap UrlTree in an observable
        }
      }),
    );
  };
}
